module.exports = __webpack_public_path__ + "img/001.69c05945.png";